import { Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/i18n';
import React, { useCallback } from 'react';
import { getErrorModalType } from '../../bi/scan-failure-bi-mapping';
import { BiCtaNames } from '../../bi/types';
import { useA11yWizardAdapter } from '../../hooks/use-a11y-wizard-adapter';
import { useBiLogger } from '../../hooks/use-bi-logger';
import { getEditorCapabilitiesForHost } from '../../utils/editor-host-to-editor-type';
import { getScanFailureContent } from '../../utils/get-scan-failure-message';
import { showErrorModal } from './show-error-modal';
export const getFailedAnalyzePagesModalProps = (t, editorHost, failureReason) => {
  const {
    usesClassicModalChrome
  } = getEditorCapabilitiesForHost(editorHost);
  const reasonContent = failureReason ? getScanFailureContent(t, failureReason) : undefined;
  const contentText = (reasonContent == null ? void 0 : reasonContent.content) ?? t('accessibility-wizard.analyze-full-site.failed-to-analyze-page-modal.content');
  const titleText = (reasonContent == null ? void 0 : reasonContent.title) ?? t('accessibility-wizard.analyze-full-site.failed-to-analyze-page-modal.title');
  return {
    content: usesClassicModalChrome ? contentText : /*#__PURE__*/React.createElement(Text, null, contentText),
    primaryButtonText: (reasonContent == null ? void 0 : reasonContent.primaryButtonText) ?? t('accessibility-wizard.analyze-full-site.failed-to-analyze-page-modal.primary-button'),
    secondaryButtonText: t('accessibility-wizard.analyze-full-site.failed-to-analyze-page-modal.secondary-button'),
    skin: 'destructive',
    title: titleText
  };
};
export const useShowFailedAnalyzePagesModal = () => {
  const {
    t
  } = useTranslation();
  const biLogger = useBiLogger();
  const {
    a11yWizardAdapter,
    editorHost
  } = useA11yWizardAdapter();
  const showFailedAnalyzePagesModal = useCallback(async function (_temp) {
    let {
      handleCancel,
      failureReason
    } = _temp === void 0 ? {} : _temp;
    const modalType = getErrorModalType(failureReason);
    const reasonContent = failureReason ? getScanFailureContent(t, failureReason) : undefined;
    const contentText = (reasonContent == null ? void 0 : reasonContent.content) ?? t('accessibility-wizard.analyze-full-site.failed-to-analyze-page-modal.content');
    biLogger.modalView({
      data: contentText,
      modalType
    });
    const modalProps = getFailedAnalyzePagesModalProps(t, editorHost, failureReason);
    await showErrorModal({
      ...modalProps,
      a11yWizardAdapter,
      editorHost,
      primaryButtonOnClick: async () => {
        biLogger.modalCtaClick({
          ctaName: BiCtaNames.Refresh,
          modalType
        });
        window.location.reload();
      },
      secondaryButtonOnClick: () => {
        biLogger.modalCtaClick({
          ctaName: BiCtaNames.Cancel,
          modalType
        });
        handleCancel == null || handleCancel();
      }
    });
  }, [a11yWizardAdapter, biLogger, editorHost, t]);
  return showFailedAnalyzePagesModal;
};
//# sourceMappingURL=show-failed-analyze-pages-modal.js.map